import React, { useEffect, useState, useRef } from "react";
import { HomeWrapper } from "../components/utils/HomeWrapper";
import { PageTitle } from "../components/utils/PageTitle";
import { checkCameraPermissions, saveVideo } from "../api/utils/webcam";
import ReactPlayer from "react-player";
import { Paper } from "@material-ui/core";
import Card from '@mui/material/Card';
import { Button, TextField } from '@mui/material';
import SendIcon from "@mui/icons-material/Send";
import Checkbox from '@mui/material/Checkbox';

import "../styles/devices/mob_VersusMachine.css";
import "../styles/devices/mob_Hub.css";
import "../styles/devices/mob_FormDialog.css";
import { RecorderSubmission } from "./RecorderSubmission";
import UpdateIcon from '@mui/icons-material/Update';
import UndoIcon from "@mui/icons-material/Undo";
import { useHistory } from 'react-router';
import { pSubmissionType } from "../utils/parameters";

import { useDataProvider } from "../api/DataProvider";
import { useCommProvider } from "../api/CommProvider";

import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";


// const CUSTOM_TIMER_DEFINITION = {
//     'max':  20,
//     'min':  4,
//     'step':  2,
//     'timer': 10
// }

const TEST_TIMER_DEFINITION = {
    'max':  20,
    'min':  2,
    'step':  2,
    'timer': 6
}


export function Submission() {
    const { t } = useTranslation("global")

    // TextFields
    const label_ref = useRef("");
    const details_ref = useRef("");
    const definition_ref = useRef("");

    const [ label, setLabel ] = useState("")
    const [ vid_gloss, setVid_gloss ] = useState(undefined)
    const [ details, setDetails ] = useState("")

    const [ definition, setDefinition ] = useState("")
    const [ vid_definition, setVid_definition ] = useState(undefined)
    const [ selected_definition, setSelected_definition ] = useState(false)

    const [ activateSendSubmission, setActivateSendSubmission ] = useState(false)
    const [ activateRecorder, setActivateRecorder ] = useState('')    // STATES:  '' : NO RECORDER, 'GLOSS' : RECORD GLOSS, 'DEFINITION' : RECORD DEFINITION

    const { comm_sendSubmission } = useCommProvider();
    const { token_id, currentUser, getListAllLemmasLabelAvailable, findSimilarWords, json_data_lemma, json_data_meaning, json_data_glosses } = useDataProvider();

    const [ similarWords, setSimilarWords ] = useState(undefined)
    const [ similarWordsIdx, setSimilarWordsIdx ] = useState(undefined)    

    const handleChange = () => {
        if (label_ref.current){
            setLabel(label_ref.current.value)
        }
        if (definition_ref.current){
            setDefinition(definition_ref.current.value)
        }
        if (details_ref.current){
            setDetails(details_ref.current.value)
        }
    };

    useEffect(() => {
        if (label.length > 2) {
            const result_findSimilarWords = findSimilarWords(label_ref.current.value)
            // console.log("🚀 ~ file: Submission.js:74 ~ useEffect ~ result_findSimilarWords:", result_findSimilarWords)
            setSimilarWords({'lemma': result_findSimilarWords['similarWords'], 'lemma_idx': result_findSimilarWords['isSimilarIds']})
        }else{
            setSimilarWords(undefined)
        }

    }, [label, definition]);

    // useEffect(() => {
    //     console.log("🚀 ~ file: Submission.js:85 ~ Submission ~ similarWords:", similarWords)
    // }, [similarWords]);

    // useEffect(() => {
    //     console.log("🚀 ~ file: Submission.js:45 ~ Submission ~ vid_gloss:", vid_gloss)
    //     console.log("🚀 ~ file: Submission.js:45 ~ Submission ~ vid_definition:", vid_definition)
    // }, [vid_gloss, vid_definition]);
    
    function handleRecordGloss(){
        setActivateRecorder('GLOSS')
    }

    function handleRecordDefinition(){
        setActivateRecorder('DEFINITION')
    }

    const history = useHistory();
    const location = useLocation();
    function returnSubmissionScreen(){
        // console.log("🚀 ~ file: Submission.js:59 ~ returnSubmissionScreen ~ returnSubmissionScreen:", returnSubmissionScreen)
        history.push({pathname: location.origin});
    }

    useEffect(() => {
        let new_activateSendSubmission = true
        if (label==='' || vid_gloss===undefined){
            new_activateSendSubmission = false
        }
        if (selected_definition){
            if (definition==='' || vid_definition===undefined){
                new_activateSendSubmission = false
            }
        }
        setActivateSendSubmission(new_activateSendSubmission)
    }, [selected_definition, label, definition, vid_gloss, vid_definition]);


    async function handleSendUserSubmission(){
        // EENVIAR USER_SUBMISSION
        const videoFile_gloss = await saveVideo(vid_gloss);
        const submission_reference = ""
        const submission_data = label+"|"+details

        // console.log('ENVIAR SIGN: ', submission_reference, submission_data)
        const response = await comm_sendSubmission(token_id, currentUser, pSubmissionType.submission_NEW_SIGN, submission_reference, submission_data, videoFile_gloss);
        // const response = {'_id': 'iddddddd'}

        
        if (selected_definition){
            const videoFile_definition = await saveVideo(vid_definition);
            const submission_reference = response['_id']+"|"+label
            const submission_data = definition
            // console.log('ENVIAR DEF: ', submission_reference, submission_data)
            await comm_sendSubmission(token_id, currentUser, pSubmissionType.submission_NEW_DEFINITION, submission_reference, submission_data, videoFile_definition);
        }
        returnSubmissionScreen()
    }

    const handleSwitchVideoSent = (word) => {
        history.push({
          pathname: "/search",
          lemma: word,
          meaning: json_data_lemma[word]['arr_meanings'][0],
          gloss: json_data_meaning[json_data_lemma[word]['arr_meanings'][0]]['arr_glosses'][0],
          video_sent: false
        });
    };
    
        
    return (
        <HomeWrapper>
            {activateRecorder ==='' ? 
            (
                <>
                <PageTitle title= {t("sSubmission.title").toUpperCase()} />
                {/* <Button style={{position: 'fixed', color: 'white', top: '75px', left:'90px'}} onClick={returnSubmissionScreen} className="sig_Collab_Terms_ReturnButton sig_Home_ChangeOnDarkMode" variant="contained">
                    <UndoIcon className="sig_Collab_UndoIcon" /> VOLVER
                </Button> */}
                <Paper className="sig_Teams_PaperContent">
                    <Card elevation={0}>
                        <div className='sig_Teams_Info_Root'>
                            <div className='sig_ProfileInfo_MainContainer'>
                                <div>
                                    <div className="sig_SignModal_PaperTitle"> {t("sSubmission.field_name")}:</div>
                                    <TextField 
                                        variant="outlined"
                                        fullWidth
                                        size="small"
                                        inputRef={label_ref}
                                        className="sig_SignModal_PaperBody"
                                        value={label}
                                        onChange={handleChange}
                                    />
                                </div>


                                {(similarWords !== undefined)
                                    ? <>
                                        {similarWords['lemma'].length > 0 ? (
                                            <p>
                                                <strong> {similarWords['lemma'].length === 1 ?  t("sSubmission.similar_word")+": " : t("sSubmission.similar_words")+": "}</strong>
                                                {similarWords['lemma'].map((word, index) => (
                                                    <>
                                                    <a
                                                        key={index}
                                                        href="#"
                                                        onClick={() => {
                                                        handleSwitchVideoSent(similarWords['lemma_idx'][index]);
                                                        // console.log(word);
                                                        }}
                                                    >
                                                        {word}
                                                    </a>
                                                    {(index < similarWords['lemma'].length -1 )?  <a>, </a> : <></>}
                                                    </>                                                    
                                                    ))
                                                }
                                            </p>
                                            ) :  <p> {t("sSubmission.no_similar_word")} </p>
                                        }
                                    </>
                                    :<></>
                                }


                                {(vid_gloss === undefined )
                                    ? <></>
                                    : <>
                                        <ReactPlayer className="sig_SignModalPaperVideo" style={{transform: 'scaleX(-1)' }} width="100%" height="auto" progressInterval={2000} url={vid_gloss} loop={true} pip={true} muted={true} controls={true} playing={true} />

                                        <div className="sig_SignModal_PaperTitle" style={{marginTop: '10px'}}> Más información (links, ejemplos...):</div>
                                        <TextField 
                                            variant="outlined"
                                            fullWidth
                                            inputRef={details_ref}
                                            multiline
                                            maxRows={4}
                                            className="sig_SignModal_PaperBody"
                                            value={details}
                                            onChange={handleChange}
                                        />
                                    </>
                                }

                                <Button className="sig_SignDialog_Button sig_SignDialog_ButtonRecord" endIcon={<SendIcon />} onClick={handleRecordGloss} disabled={label==""}>
                                    {vid_gloss === undefined  ? t("sSubmission.recordSignButton").toUpperCase() : t("sSubmission.repeatSignButton").toUpperCase()}
                                </Button>


                                <div style={{display: 'flex', width: '100%', margin: 'auto'}}>
                                    <Checkbox style={{marginRight: '5px'}} onClick={() => setSelected_definition(!selected_definition)} checked={selected_definition} disabled={label==="" || vid_gloss===undefined} />
                                    <div className="sig_SignModal_PaperTitle"> {t("sSubmission.field_check_add_definition")}: </div>
                                </div>

                                {( selected_definition )
                                    ? (
                                    <>
                                        <div>
                                            <TextField 
                                                variant="outlined"
                                                fullWidth
                                                inputRef={definition_ref}
                                                multiline
                                                maxRows={4}
                                                className="sig_SignModal_PaperBody"
                                                value={definition}
                                                onChange={(e) => handleChange()}
                                            />
                                        </div>

                                        {(vid_definition === undefined )
                                            ? <></>
                                            : <ReactPlayer className="sig_SignModalPaperVideo" width="100%" height="auto" progressInterval={2000} url={vid_definition} loop={true} pip={true} muted={true} controls={true} playing={true} />
                                        }
                                    
                                        <Button className="sig_SignDialog_Button sig_SignDialog_ButtonRecord" endIcon={<SendIcon />} onClick={handleRecordDefinition} disabled={definition==""}>
                                            {vid_definition === undefined  ? t("sSubmission.recordDefButton").toUpperCase() : t("sSubmission.repeatSignButton").toUpperCase()}
                                        </Button>

                                    </>
                                    ): <></>
                                }

                                

                                    <div className="sig_BugReport_ButtonsContainer">
                                        <Button className="sig_SignDialog_Button sig_SignDialog_AcceptButton" onClick={handleSendUserSubmission} disabled={!activateSendSubmission}>
                                            {t("strButton.btn_send").toUpperCase()}
                                        </Button>
                                        <Button className="sig_SignDialog_Button sig_SignDialog_CancelButton" onClick={returnSubmissionScreen}>
                                            {t("strButton.btn_cancel").toUpperCase()}
                                        </Button>
                                    </div>  


                            </div> 
                        </div>
                    </Card>    
                </Paper>
                </>
            ):(
                <RecorderSubmission sign={label} setMediaBlobUrl={activateRecorder === 'GLOSS' ? setVid_gloss : setVid_definition} setActivateRecorder={setActivateRecorder} customTimer={activateRecorder === 'DEFINITION' ? TEST_TIMER_DEFINITION : undefined}/>
            )
            }

        </HomeWrapper>
    );
}

